import { Breadcrumb, Button, Flex, Layout, Rate, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import mp from './[manufacturer_name].module.scss';
import { useRouter } from 'next/router';
import { usePathname, useSearchParams } from 'next/navigation';
import WithMainContainer from '@/components/layout';
import CatalogExplorerItem from '@/widgets/CatalogExplorerItem/CatalogExplorerItem';
import Head from 'next/head';
import { useStores } from '@/utils/hooks/useStores';
import { QueryService } from 'tkmp-lib/dist/services/QueryService';
import useLocalization from 'tkmp-lib/dist/hooks/useLocalization';
import HeadService from '@/utils/services/HeadService';

export async function getServerSideProps(context: { params: any }) {
    const { params } = context;
    const { manufacturer_name } = params;
    const locale = QueryService.getLocale(context);

    const manufacturer = await QueryService.request(
        `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${locale}/organisation/${manufacturer_name}`,
    );

    return {
        props: {
            manufacturer,
            manufacturer_name,
        },
    };
}

function ManufacturerPage({ manufacturer, manufacturer_name }: any) {
    const router = useRouter();
    const searchParams = useSearchParams();
    const pathname = usePathname();
    const LOCALIZATION = useLocalization();
    console.log('asdasdasd', manufacturer);

    const manufacturer_id = router.query.manufacturer_name;

    const [manufacturerDescription, setManufacturerDescription] = useState([]);
    const [manufacturerGoods, setManufacturerGoods] = useState([]);

    const {
        systemStore: { setBreadcrumbs },
    } = useStores();

    useEffect(() => {
        // if (manufacturer) {
        setBreadcrumbs([
            {
                key: '/',
                title: LOCALIZATION.routes.home,
            },
            {
                key: '/manufacturers',
                title: LOCALIZATION.routes.manufacturers,
            },
            {
                key: `/manufacturer/${manufacturer_id}`,
                title: manufacturer?.fullname,
            },
        ]);

        QueryService.request(
            `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${router.locale}/catalog/org/${manufacturer?.slug}/category/home`,
        ).then((response: any) => {
            console.log('Org dto', manufacturer);
            console.log('Org Categories', response);
            console.log(
                'Build url -> ',
                `${process.env.NEXT_PUBLIC_DOMAIN_BFF}/tkmp/v1/${router.locale}/catalog/org/${manufacturer?.slug}/category/home`,
            );
            setManufacturerGoods(response?.inner);
        });

        if (manufacturer?.description) {
            const result: string[] = [];
            manufacturer?.description?.replace(/[\s\S]*?[\.|!|\?]/gm, (text: string) => {
                result.push(text);
            });
            setManufacturerDescription(result as any);
        }
        // }
    }, [LOCALIZATION.locale]);

    return (
        <>
            {process.env.NEXT_PUBLIC_INCLUDE_SEO_TAGS === 'true' &&
                HeadService.simpleBuild(
                    `Производитель ${manufacturer?.fullname ?? manufacturer?.name} - TKMP.Istok`,
                    `/manufacturer/${manufacturer_name}`,
                    [
                        {
                            key: 'description',
                            value: `${manufacturer?.description?.replace(
                                /[\s\S]*?[\.|!|\?]/gm,
                                (text: any, i: number) => {
                                    if (i === 0) return text;
                                    else return '';
                                },
                            )}`,
                        },
                        {
                            key: 'keywords',
                            value: `B2B, маркетплейс, закупки, поставщики, TKMP.Istok, производители, ${manufacturer?.fullname ?? ''}, ${manufacturer?.requisites?.company_name ?? ''}`,
                        },
                        {
                            key: 'og:title',
                            value: `Производитель ${manufacturer?.fullname} - TKMP.Istok`,
                        },
                        {
                            key: 'og:description',
                            value: `${manufacturer?.description?.replace(
                                /[\s\S]*?[\.|!|\?]/gm,
                                (text: any, i: number) => {
                                    if (i === 0) return text;
                                    else return '';
                                },
                            )}`,
                        },
                        {
                            key: 'og:image',
                            value: `${process.env.NEXT_PUBLIC_DOMAIN_CDN}${manufacturer?.logo}`,
                        },
                        {
                            key: 'twitter:image',
                            value: `${process.env.NEXT_PUBLIC_DOMAIN_CDN}${manufacturer?.logo}`,
                        },
                    ],
                )}
            <Flex
                vertical
                className={mp.container}
            >
                <Breadcrumb />
                <Layout className={mp.container_header}>
                    <Flex className={mp.container_header__HOST}>
                        <div
                            style={{
                                backgroundImage: `url(${process.env.NEXT_PUBLIC_DOMAIN_CDN}${manufacturer?.logo})`,
                            }}
                            className={mp.container_header__logo}
                        ></div>
                        <Flex
                            vertical
                            className={mp.container_header__title}
                        >
                            <Typography.Text className={mp.container_header__title_brandName}>
                                {manufacturer?.name}
                                {LOCALIZATION.pages.manufacturer.header.title}
                            </Typography.Text>
                            <Layout className={mp.container_header_title_rating}>
                                <Rate
                                    disabled
                                    allowHalf
                                    defaultValue={manufacturer?.rating ?? 4.7}
                                    style={{ color: '#8D24F8', fontSize: 10 }}
                                />
                            </Layout>
                        </Flex>
                    </Flex>
                </Layout>
                <Flex
                    className={mp.container_body__description}
                    justify={'space-between'}
                >
                    <Flex className={mp.container_body__description_leftSide}>
                        <Typography.Text className={mp.container_body__description_leftSide__title}>
                            {LOCALIZATION.pages.manufacturer.companyInfo.title}
                        </Typography.Text>
                    </Flex>
                    <Flex
                        vertical
                        className={mp.container_body__description_rightSide}
                    >
                        <Flex
                            vertical
                            className={mp.container_body__description_rightSide__textBlock}
                        >
                            {manufacturerDescription?.map((text: any, i: any) => (
                                <Typography.Text
                                    key={i}
                                    className={mp.container_body__description_rightSide__textItem}
                                >
                                    {text}
                                </Typography.Text>
                            ))}
                        </Flex>
                        <Button
                            type={'link'}
                            onClick={() => {
                                const type =
                                    searchParams.get('type') === 'goods' ? {} : { type: 'goods' };
                                router.push({
                                    pathname: pathname,
                                    query: type,
                                });
                            }}
                            className={mp.container_body__description_rightSide__link_all}
                        >
                            {searchParams.get('type') !== 'goods'
                                ? LOCALIZATION.pages.manufacturer.companyInfo.allProductsButton
                                : LOCALIZATION.pages.manufacturer.companyInfo.companyPageButton}
                        </Button>
                        <Button
                            disabled
                            ghost
                            className={mp.container_body__description_rightSide__button_write}
                        >
                            {LOCALIZATION.pages.manufacturer.companyInfo.contactButton}
                        </Button>
                    </Flex>
                </Flex>
                {searchParams.get('type') === 'goods' && (
                    <Flex gap={'small'}>
                        {manufacturerGoods?.map((category: any, i) => {
                            const newCategory: any = {
                                ...(category as object),
                                fpathSlug: [...category?.fpathSlug, 'brand', manufacturer?.slug],
                            };
                            return (
                                <CatalogExplorerItem
                                    key={i}
                                    element={newCategory}
                                />
                            );
                        })}
                    </Flex>
                )}
                {searchParams.get('type') !== 'goods' && (
                    <>
                        <Flex className={mp.container_body__addition}>
                            <Flex
                                vertical
                                className={mp.container_body__addition_leftSide}
                            >
                                <Typography.Text className={mp.container_body__addition_title}>
                                    {LOCALIZATION.pages.manufacturer.requisites.title}
                                </Typography.Text>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                {
                                                    LOCALIZATION.pages.manufacturer.requisites
                                                        .fields.companyName
                                                }
                                            </td>
                                            <td>{manufacturer?.name}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {
                                                    LOCALIZATION.pages.manufacturer.requisites
                                                        .fields.legalAddress
                                                }
                                            </td>
                                            <td>
                                                {manufacturer?.requisites?.legalAddress ??
                                                    LOCALIZATION.pages.manufacturer.requisites
                                                        .notSpecified}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {
                                                    LOCALIZATION.pages.manufacturer.requisites
                                                        .fields.actualAddress
                                                }
                                            </td>
                                            <td>
                                                {manufacturer?.requisites?.actualAddress ??
                                                    LOCALIZATION.pages.manufacturer.requisites
                                                        .notSpecified}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {
                                                    LOCALIZATION.pages.manufacturer.requisites
                                                        .fields.ogrn
                                                }
                                            </td>
                                            <td>
                                                {manufacturer?.requisites?.ogrn ??
                                                    LOCALIZATION.pages.manufacturer.requisites
                                                        .notSpecified}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {
                                                    LOCALIZATION.pages.manufacturer.requisites
                                                        .fields.inn
                                                }
                                            </td>
                                            <td>
                                                {manufacturer?.requisites?.inn ??
                                                    LOCALIZATION.pages.manufacturer.requisites
                                                        .notSpecified}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {
                                                    LOCALIZATION.pages.manufacturer.requisites
                                                        .fields.kpp
                                                }
                                            </td>
                                            <td>
                                                {manufacturer?.requisites?.kpp ??
                                                    LOCALIZATION.pages.manufacturer.requisites
                                                        .notSpecified}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Flex>
                            <Layout className={mp.container_body__addition_rightSide}>
                                {!!manufacturer?.location?.latitude &&
                                    !!manufacturer?.location?.longitude && (
                                        <iframe
                                            src={`https://yandex.ru/map-widget/v1/?ll=${manufacturer?.location?.longitude}%2C${manufacturer?.location?.latitude}&z=12&pt=${manufacturer?.location?.longitude},${manufacturer?.location?.latitude}`}
                                            width="100%"
                                            height="100%"
                                            allowFullScreen={true}
                                        ></iframe>
                                    )}
                            </Layout>
                        </Flex>
                        <Flex
                            vertical
                            className={mp.container_body__rating}
                        >
                            <Typography.Text className={mp.container_body__rating_title}>
                                {LOCALIZATION.pages.manufacturer.reviews.title}
                            </Typography.Text>
                            <Flex className={mp.container_body__rating_list}>
                                {Array(3)
                                    .fill('')
                                    .map((_, index) => (
                                        <Flex
                                            vertical
                                            key={index}
                                            className={mp.container_body__rating_item}
                                        >
                                            <Typography.Text
                                                className={mp.container_body__rating_item__userName}
                                            >
                                                {
                                                    LOCALIZATION.pages.manufacturer.reviews
                                                        .defaultUserName
                                                }
                                            </Typography.Text>
                                            <Typography.Text
                                                className={mp.container_body__rating_item__userDate}
                                            >
                                                22.05.2024
                                            </Typography.Text>
                                            <Typography.Text
                                                className={mp.container_body__rating_item__userText}
                                            >
                                                {
                                                    LOCALIZATION.pages.manufacturer.reviews
                                                        .defaultText
                                                }
                                            </Typography.Text>
                                            <Flex
                                                className={
                                                    mp.container_body__rating_item__userRating
                                                }
                                            >
                                                <Rate
                                                    disabled
                                                    allowHalf
                                                    defaultValue={4.7}
                                                    style={{ color: '#8D24F8', fontSize: 10 }}
                                                />
                                            </Flex>
                                        </Flex>
                                    ))}
                            </Flex>
                        </Flex>{' '}
                    </>
                )}
            </Flex>
        </>
    );
}

export default WithMainContainer(ManufacturerPage);
